export default {
    en: {
        id: 'exercise5',
        answers: [
            {
                title: `<div class="box-title">Difficult to develop compelling business case for entering</div>`,
                answer: 1,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Other assumptions may be wrong</div>`,
                answer: 2,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Grow through externally and internally sourced products</div>
                        <div>Develop blockbuster products</div>`,
                answer: 3,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Get external validation of potential future development and best practice from Chinese-based expert</div>`,
                answer: 4,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Slade affiliate in China says that Marketing & Sales will turn out to be a set % of net sales all along the process</div>`,
                answer: 5,
                hasArrow: true
            }
        ],
        image: 'section-5d-5.png'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5d/writingProposalsPlans/i18n/exercise5.js